// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1VYc8","location":"Header_location__1zm38"};